import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { calendarActions } from '../../../store/calendar';

class Test extends React.Component {

    componentDidMount() {
        this.props.getTest();
    }

    render() {
        console.log(this.props);
        return (
            <div className="container g-my-30">

            </div>
        )
    }
}

export default connect(
    state => state.calendar,
    dispatch => bindActionCreators({ ...calendarActions }, dispatch)
)(withRouter(Test));


// WEBPACK FOOTER //
// ./src/pages/front/home/test.js